import { render, staticRenderFns } from "./CreateGrantCredit.vue?vue&type=template&id=0120a8e0&scoped=true&"
import script from "./CreateGrantCredit.vue?vue&type=script&lang=js&"
export * from "./CreateGrantCredit.vue?vue&type=script&lang=js&"
import style0 from "./CreateGrantCredit.vue?vue&type=style&index=0&id=0120a8e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0120a8e0",
  null
  
)

export default component.exports